var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBoxArchive = function SvgBoxArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 16.563V9.125h12.25v7.438c0 .738-.602 1.312-1.313 1.312H7.188a1.296 1.296 0 0 1-1.312-1.313Zm3.5-5.36v.219c0 .191.137.328.328.328h4.594a.332.332 0 0 0 .328-.328v-.219a.353.353 0 0 0-.328-.328H9.703a.333.333 0 0 0-.328.328Zm8.75-5.578A.9.9 0 0 1 19 6.5v1.313a.45.45 0 0 1-.438.437H5.438A.432.432 0 0 1 5 7.812V6.5c0-.465.383-.875.875-.875h12.25Z"
  })));
};

export default SvgBoxArchive;